export type StudentAgeGroup =
  | "A Level"
  | "GCSE"
  | "KS3"
  | "Primary"
  | "unknown";

export function getStudentAgeGroupFromYearGroup(
  yearGroup: number
): Exclude<StudentAgeGroup, "unknown"> {
  if (yearGroup > 11) return "A Level";

  if (yearGroup > 9) return "GCSE";

  if (yearGroup > 6) return "KS3";

  return "Primary";
}
